module.exports = __webpack_public_path__ + "images/[11].jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/slider/[11].jpeg
// module id = 42
// module chunks = 0